import { isProduction } from '../isProduction';
import { withTimeout } from '../withTimeout';

import { KASPERSKY_DAS_SCRIPT_ID, KASPERSKY_DAS_SCRIPT_LOAD_TIMEOUT_MS, KASPERSKY_DAS_SCRIPT_SRC } from './constants';
import { isKfpReady } from './isKfpReady';

let loadPromise: Promise<void> | null = null;

const injectDasScript = (): Promise<void> =>
  new Promise((resolve) => {
    if (document.getElementById(KASPERSKY_DAS_SCRIPT_ID)) {
      resolve();
      return;
    }

    const el = document.createElement('script');
    el.id = KASPERSKY_DAS_SCRIPT_ID;
    el.async = true;
    el.src = isProduction() ? KASPERSKY_DAS_SCRIPT_SRC.prod : KASPERSKY_DAS_SCRIPT_SRC.dev;
    el.addEventListener('load', () => resolve(), { once: true });
    el.addEventListener('error', () => resolve(), { once: true });
    document.head.appendChild(el);
  });

const loadDasScriptOnce = async (): Promise<void> => {
  try {
    await withTimeout(injectDasScript(), KASPERSKY_DAS_SCRIPT_LOAD_TIMEOUT_MS, undefined);
  } catch {}
};

export const ensureDasScriptLoaded = async () => {
  if (isKfpReady()) {
    return;
  }

  if (!loadPromise) {
    loadPromise = loadDasScriptOnce();
  }

  await loadPromise;
};
